import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { api } from "../lib/api";
import { Loader2, Upload, X } from "lucide-react";
import { toast } from "sonner";

export default function DropZone({ onUploaded, multiple = true, accept = { "image/*": [] }, hint }) {
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const onDrop = useCallback(async (files) => {
    if (!files?.length) return;
    setUploading(true);
    setProgress(0);
    const out = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fd = new FormData();
      fd.append("file", file);
      try {
        const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        out.push(data);
      } catch (e) {
        toast.error(`Erro ao enviar ${file.name}`);
      }
      setProgress(Math.round(((i + 1) / files.length) * 100));
    }
    setUploading(false);
    setProgress(0);
    if (out.length) onUploaded?.(multiple ? out : out[0]);
  }, [multiple, onUploaded]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple, accept });

  return (
    <div {...getRootProps()} data-testid="dropzone" className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition ${isDragActive ? "border-accent-yellow bg-accent-yellow/10" : "border-black/15 hover:border-black/40"}`}>
      <input {...getInputProps()} />
      {uploading ? (
        <div className="flex flex-col items-center gap-2 text-sm">
          <Loader2 className="w-5 h-5 animate-spin" /> Enviando… {progress}%
        </div>
      ) : (
        <div className="text-sm text-neutral-600 flex flex-col items-center gap-2">
          <Upload className="w-5 h-5" />
          {isDragActive ? "Solte aqui" : "Arraste arquivos aqui ou clique para enviar"}
          <span className="text-xs text-neutral-400">{hint || "Imagens · até 25MB"}</span>
        </div>
      )}
    </div>
  );
}
